import * as React from 'react';
import loadingCircle from '../../../../../mainAssets/images/loaders/loadingcircle.png';

const styles = require('./styles/LoadingSpinner.css');

interface ILoadingSpinnerProps {
	width?: number;
	height?: number;
	style?: React.CSSProperties;
	className?: string;
}

export const LoadingSpinner: React.SFC<ILoadingSpinnerProps> = (props) => {
	return (
		<img
			className={`${styles.loadingSpinner} ${props.className}`}
			src={loadingCircle}
			width={props.width}
			height={props.height}
			style={props.style}
		/>
	);
};

LoadingSpinner.defaultProps = {
	height: 20,
	width: 20,
};

export default LoadingSpinner;
